"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

var _areaGraphModule = _interopRequireDefault(require("./sass/areaGraph.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AreaGraph = function AreaGraph(_ref) {
  var _areaGraphClasses;

  var areasShapes = _ref.areasShapes,
      colorGuarantee = _ref.colorGuarantee,
      className = _ref.className,
      customLegend = _ref.customLegend,
      customTooltip = _ref.customTooltip,
      data = _ref.data,
      dataKeyX = _ref.dataKeyX,
      guarantee = _ref.guarantee,
      height = _ref.height,
      marginChart = _ref.marginChart,
      marginX = _ref.marginX,
      marginY = _ref.marginY,
      showReference = _ref.showReference,
      styleXAxis = _ref.styleXAxis,
      styleYAxis = _ref.styleYAxis,
      wrapperStyleLegend = _ref.wrapperStyleLegend;
  var areaGraphClasses = (_areaGraphClasses = {}, _defineProperty(_areaGraphClasses, _areaGraphModule.default.areaGraph, true), _defineProperty(_areaGraphClasses, "className", className), _areaGraphClasses);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(areaGraphClasses),
    style: {
      height: "".concat(height, "px")
    }
  }, /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_recharts.AreaChart, {
    data: data,
    margin: marginChart
  }, /*#__PURE__*/_react.default.createElement(_recharts.XAxis, {
    dataKey: dataKeyX,
    interval: "preserveEnd",
    padding: {
      left: 20
    },
    tickLine: false,
    tickSize: marginX,
    stroke: "#546982",
    tick: styleXAxis
  }), /*#__PURE__*/_react.default.createElement(_recharts.YAxis, {
    stroke: "#546982",
    tickLine: false,
    tickSize: marginY,
    tick: styleYAxis
  }), /*#__PURE__*/_react.default.createElement(_recharts.Legend, {
    content: customLegend,
    wrapperStyle: wrapperStyleLegend
  }), /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
    content: customTooltip
  }), areasShapes.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_recharts.Area, {
      key: "AreaShape_".concat(index),
      dataKey: item.dataKey,
      stackId: item.stackId,
      stroke: item.stroke,
      fill: item.fill,
      fillOpacity: item.fillOpacity
    });
  }), /*#__PURE__*/_react.default.createElement(_recharts.ReferenceLine, {
    y: guarantee,
    stroke: colorGuarantee,
    strokeDasharray: "8 8",
    isFront: true,
    strokeWidth: 2,
    alwaysShow: showReference
  }))));
};

AreaGraph.propTypes = {
  data: _propTypes.default.array,
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  height: _propTypes.default.number,
  guarantee: _propTypes.default.number
};
var _default = AreaGraph;
exports.default = _default;